// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3Kpo-","upload":"Small_upload__2wJa_","imageWrap":"Small_imageWrap__mR6wc","removeBtn":"Small_removeBtn__2lq9R"};